export default "__VITE_ASSET__sRjydWJr__"